import {Frontend} from "./frontend";

(function () {
    XonBoard.AdvancedGeneratorMonitorSensorReads = {
        list: {

            selectors: {
                sensor_reads_table: $('#sensor-reads-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.sensor_reads_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensor_reads_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsTotal);
                            return json.data;
                        },
                        data(d) {
                            const from_datetime = $('#from_datetime').val();
                            if (from_datetime) {
                                d.from_datetime = from_datetime;
                            }

                            const to_datetime = $('#to_datetime').val();
                            if (to_datetime) {
                                d.to_datetime = to_datetime;
                            }
                        },
                    },
                    columns: [
                        {data: 'received_date', name: 'sensor_reads.received_date', createdCell: self.renderCell,},
                        {data: 'engine_battery_voltage', name: 'sensor_reads.values->engine_battery_voltage', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'oil_pressure', name: 'sensor_reads.values->oil_pressure', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'coolant_temperature', name: 'sensor_reads.values->coolant_temperature', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'fuel_level', name: 'sensor_reads.values->fuel_level', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'phase_1_voltage', name: 'sensor_reads.values->phase_1_voltage', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'phase_2_voltage', name: 'sensor_reads.values->phase_2_voltage', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'phase_3_voltage', name: 'sensor_reads.values->phase_3_voltage', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'phase_1_current', name: 'sensor_reads.values->phase_1_current', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'phase_2_current', name: 'sensor_reads.values->phase_2_current', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'phase_3_current', name: 'sensor_reads.values->phase_3_current', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'phase_1_power', name: 'sensor_reads.values->phase_1_power', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'phase_2_power', name: 'sensor_reads.values->phase_2_power', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'phase_3_power', name: 'sensor_reads.values->phase_3_power', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'fuel_consumption', name: 'sensor_reads.values->fuel_consumption', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'generator_total_watts', name: 'sensor_reads.values->generator_total_watts', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'engine_running_hour', name: 'sensor_reads.values->engine_running_hour', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'energy', name: 'sensor_reads.values->energy', createdCell: self.renderCell, sortable: false, searchable: false},
                        {data: 'frequency', name: 'sensor_reads.values->frequency', createdCell: self.renderCell, sortable: false, searchable: false},
                        {
                            data: 'actions',
                            name: 'actions',
                            searchable: false,
                            sortable: false,
                            createdCell: self.renderCell,
                        }
                    ],
                    order: [[0, "desc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
            renderCell(td, cellData) {
                if (cellData && cellData.value != null) {
                    $(td).addClass(cellData.class);
                    $(td).html(cellData.value);
                    return;
                }

                $(td).html(cellData);
            }
        },
    }
})();
